import { h } from "preact";
import { Route, Redirect } from "react-router-dom";

export const ProtectedComponentRoute = ({ condition, component: Component, redirect = "/", ...rest }) => (
    <Route
        {...rest}
        render={props =>
            condition ? (
                <Component {...props} />
            ) : (
                <Redirect to={redirect} />
            )
        }
    />
);
